import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import "./TableButtons.css";

/**
 * SelectRowButton - Right arrow button for selecting/navigating to row details
 * 
 * @example
 * <SelectRowButton onClick={handleSelect} disabled={noRevisions} />
 */
const SelectRowButton = ({ onClick, disabled = false, ariaLabel = "Select row", ...props }) => {
  return (
    <button
      className="right-arrow"
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      title={disabled ? "No revisions available" : "View details"}
      {...props}
    >
      <FontAwesomeIcon icon={faArrowRight} />
    </button>
  );
};

export default SelectRowButton;

